const NavigationDispatch = 'NavigationDispatch';
const NavigationNavigate = 'NavigationNavigate';
const BarcodeScreen = 'AddFromCatalogStackBarcodeScreen';
const LogCustom = 'LogEvent';

const sendMessage = (message) => {
  setTimeout(function () {
    try {
      window.scPostMessage(message);
    } catch (e) {
      window.ReactNativeWebView && window.ReactNativeWebView.postMessage(message);
    }
  }, 100);
};

export default {
  navigationDispatch (params) {
    sendMessage(JSON.stringify({
      type: NavigationDispatch,
      ...params,
    }));
  },
  changeUrl (url, pageName = 'QuestionDetail') {
    this.navigationDispatch({
      pageName,
      url,
    });
  },
  navigationNavigate (params) {
    sendMessage(JSON.stringify({
      type: NavigationNavigate,
      ...params,
    }));
  },
  openBarcodePage () {
    this.navigationDispatch({
      pageName: BarcodeScreen,
    });
  },
  openProductDetail (params) {
    this.navigationDispatch({
      pageName: 'ProductDetailV2',
      url: params,
    });
  },
  pushGAEvent (params) {
    sendMessage(JSON.stringify({
      type: LogCustom,
      ...params,
    }));
  },
};
